import { useSearchParams, useNavigate } from 'react-router';
import { VegaBox, VegaButton, VegaFlex, VegaFont } from '@globalpayments/vega-react';

const ErrorPage = () => {
  const [searchParams] = useSearchParams();
  const errType = searchParams.get('errType');
  const navigate = useNavigate();

  let content: React.ReactNode;

  if (errType === 'sessionInfo') {
    content = (
      <>
        <VegaFont as="h1" variant="font-h2">Oops, that session doesn't exist!</VegaFont>
        <VegaButton label="Return to Application Lookup" onVegaClick={() => navigate('/userlookup')} />
      </>
    );
  } else if (errType === 'callFailed') {
    content = (
      <>
        <VegaFont as="h1" variant="font-h2">We're having some issues getting data right now.</VegaFont>
        <VegaFont as="h2" variant="font-h3">Please try to log out and log back in.</VegaFont>
      </>
    );
  } else if (errType === '401') {
    content = <VegaFont as="h1" variant="font-h2">You do not have authorization to visit this page.</VegaFont>;
  } else {
    content = (
      <>
        <VegaFont as="h1" variant="font-h2">We're having issues at the moment.</VegaFont>
        <VegaFont as="h2" variant="font-h3">Please contact support, or try again later.</VegaFont>
      </>
    );
  }

  return (
    <VegaBox width="95%">
      <VegaFlex alignItems="center" direction="col" gap="size-16" justifyContent="center">
        {content}
      </VegaFlex>
    </VegaBox>
  );
};

export default ErrorPage;
